import { HTTP_TOKEN } from "./http";

export const getWhatsApps = (params) => {
  return HTTP_TOKEN.get("whatsapp", { params }).then((result) => {
    return result.data;
  });
};

export const getWhatsApp = (whatsId) => {
  return HTTP_TOKEN.get(`whatsapp/${whatsId}`).then((result) => {
    return result.data;
  });
};

export const createWhatsApp = (data) => {
  return HTTP_TOKEN.post("whatsapp", data).then((result) => {
    return result.data;
  });
};

export const updateWhatsApp = (whatsId, params) => {
  return HTTP_TOKEN.put(`whatsapp/${whatsId}`, params).then((result) => {
    return result.data;
  });
};

export const deleteWhatsApp = (whatsId) => {
  return HTTP_TOKEN.delete(`whatsapp/${whatsId}`, {}).then((result) => {
    return result.data;
  });
};

export const getWhatsAppStatus = (whatsId) => {
  return HTTP_TOKEN.get(`whatsapp/${whatsId}/status`).then((result) => {
    return result.data;
  });
};

export const getWhatsAppPhone = (whatsId) => {
  return HTTP_TOKEN.get(`whatsapp/${whatsId}/phone`).then((result) => {
    return result.data;
  });
};

export const getWhatsAppQRCODE = (whatsId) => {
  return HTTP_TOKEN.get(`whatsapp/${whatsId}/qrcode`).then((result) => {
    return result.data;
  });
};
